import React from 'react';
import classNames from 'classnames';

function getButtonElement(props, content, disabled, styles, target) {
  const buttonClasses = classNames(styles);

  return typeof target === 'string' ? (
    <a className={buttonClasses} href={target} {...props}>
      {content}
    </a>
  ) : (
    <button
      disabled={disabled}
      className={buttonClasses}
      onClick={target}
      {...props}
    >
      {content}
    </button>
  );
}

export { getButtonElement };
